import React, { createContext, useContext, useReducer } from 'react';

const MapContext = createContext();

const initialState = {
  bounds: null,
  center: [40.7128, -74.0060], // Default to New York
  zoom: 13,
  lastViewedCoordinates: null,
  markers: [],
  loading: false,
};

const mapReducer = (state, action) => {
  switch (action.type) {
    case 'SET_BOUNDS':
      return {
        ...state,
        bounds: action.payload,
      };
    
    case 'SET_CENTER':
      return {
        ...state,
        center: action.payload,
      };
    
    case 'SET_ZOOM':
      return {
        ...state,
        zoom: action.payload,
      };
    
    case 'SET_LAST_VIEWED':
      return {
        ...state,
        lastViewedCoordinates: action.payload,
      };
    
    case 'SET_MARKERS':
      return {
        ...state,
        markers: action.payload,
      };
    
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.payload,
      };
    
    case 'UPDATE_MAP_STATE':
      return {
        ...state,
        ...action.payload,
      };
    
    default:
      return state;
  }
};

export const MapProvider = ({ children }) => {
  const [state, dispatch] = useReducer(mapReducer, initialState);

  const updateBounds = (bounds) => {
    dispatch({ type: 'SET_BOUNDS', payload: bounds });
  };

  const updateCenter = (center) => {
    dispatch({ type: 'SET_CENTER', payload: center });
  };

  const updateZoom = (zoom) => {
    dispatch({ type: 'SET_ZOOM', payload: zoom });
  };

  const setLastViewed = (coordinates) => {
    dispatch({ type: 'SET_LAST_VIEWED', payload: coordinates });
    localStorage.setItem('lastViewedCoordinates', JSON.stringify(coordinates));
  };

  const setMarkers = (markers) => {
    dispatch({ type: 'SET_MARKERS', payload: markers });
  };

  const setLoading = (loading) => {
    dispatch({ type: 'SET_LOADING', payload: loading });
  };

  const updateMapState = (updates) => {
    dispatch({ type: 'UPDATE_MAP_STATE', payload: updates });
  };

  const restoreLastViewed = () => {
    const stored = localStorage.getItem('lastViewedCoordinates');
    if (stored) {
      try {
        const coordinates = JSON.parse(stored);
        setLastViewed(coordinates);
        updateCenter(coordinates.center || coordinates);
        updateZoom(coordinates.zoom || 13);
      } catch (error) {
        console.error('Failed to restore last viewed coordinates:', error);
      }
    }
  };

  const value = {
    ...state,
    updateBounds,
    updateCenter,
    updateZoom,
    setLastViewed,
    setMarkers,
    setLoading,
    updateMapState,
    restoreLastViewed,
  };

  return <MapContext.Provider value={value}>{children}</MapContext.Provider>;
};

export const useMap = () => {
  const context = useContext(MapContext);
  if (!context) {
    throw new Error('useMap must be used within a MapProvider');
  }
  return context;
};
